var icon = require('vue-svgicon')
icon.register({
  'ks-icon-pencil': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M104.64 40.86a4.65 4.65 0 0 0 0-6.58L93.72 23.36a4.65 4.65 0 0 0-6.58 0l-8.59 8.54 17.5 17.5M22 88.5V106h17.5l51.61-51.65-17.5-17.5z"/>'
  }
})
